module.exports = __webpack_public_path__ + "img/cute_natural_doodle_10.8ab43700.png";